import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
const benefits = [{
  icon: '📚',
  title: 'Los 6 Tomos del Método',
  desc: 'Tu año completo ya planificado — abres, lees y enseñas.',
  bullets: ['Formación Base (U10/U12): La base del movimiento', 'Desarrollo (U13/U15): Transición al sistema de juego', 'Perfeccionamiento (U17/U19): Táctica y alta competencia'],
  value: 'USD 97'
}, {
  icon: '💪',
  title: 'Preparación y Drills Pro',
  desc: 'Ejercicios específicos para potenciar el rendimiento físico y técnico.',
  bullets: ['Preparación Física: Salto, potencia y prevención', '101 Drills Pro: Los favoritos de la Prof. Valentina Ríos', 'Gestión y Liderazgo: Mentalidad ganadora'],
  value: 'USD 47'
}, {
  icon: '💥',
  title: 'KIT TÁCTICO PRO',
  desc: 'La herramienta digital definitiva para llevar tu táctica al siguiente nivel.',
  bullets: ['Playbook Visual HD: Sistemas 5-1, 4-2 y 6-0', 'Pizarras Tácticas Imprimibles para explicar jugadas', 'Sistema de Señales Visuales para partidos'],
  value: 'USD 57'
}, {
  icon: '📊',
  title: 'Scouting y Evaluación',
  desc: 'Mide el progreso real de tu equipo con herramientas profesionales.',
  bullets: ['Tarjetas de Scout Individual', 'Medición de rendimiento en cancha', 'Control de estadísticas clave'],
  value: 'USD 49'
}];
const headlineStats = [{
  num: '300+',
  label: 'Drills'
}, {
  num: '6',
  label: 'Volúmenes'
}, {
  num: '+12',
  label: 'Meses de clases'
}, {
  num: '100%',
  label: 'Editable'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-1">
      {/* Soft background glow */}
      <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-primary/8 rounded-full blur-[120px] pointer-events-none hidden sm:block" data-id="element-2"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-3">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-14" data-id="element-4">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-5">
            🎁 Lo que recibes hoy (Todo incluido)
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-6">
            Todo lo que necesitas,{' '}
            <span className="text-primary" data-id="element-7">en un solo lugar</span>.
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-8">
            Cuatro pilares de contenido técnico para eliminar el estrés semanal
            y elevar la calidad de cada entrenamiento que das.
          </p>
        </div>

        {/* Headline stats strip */}
        <div className="grid grid-cols-4 gap-2 sm:gap-4 mb-10 sm:mb-14 max-w-3xl mx-auto" data-id="element-9">
          {headlineStats.map((s, i) => <div key={i} className="bg-bg-alt border border-border-light rounded-xl py-3 sm:py-4 px-2 text-center" data-id="element-10">
              <p className="text-primary font-black text-lg sm:text-2xl leading-none mb-1" data-id="element-11">
                {s.num}
              </p>
              <p className="text-text-sec text-[10px] sm:text-xs font-medium uppercase tracking-wider" data-id="element-12">
                {s.label}
              </p>
            </div>)}
        </div>

        {/* Benefit cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6" data-id="element-13">
          {benefits.map((benefit, i) => <article key={i} className="bg-bg-alt rounded-3xl border border-border-light p-6 sm:p-8 flex flex-col relative overflow-hidden hover:-translate-y-1 hover:border-primary/40 hover:shadow-[0_18px_40px_-15px_rgba(30,64,175,0.2)] transition-all duration-300 group shadow-[0_4px_20px_-10px_rgba(30,64,175,0.08)]" data-id="element-14">
              {/* "Incluido" badge */}
              <div className="absolute top-5 right-5 sm:top-6 sm:right-6 flex items-center gap-1.5 bg-cta-green/10 text-cta-green border border-cta-green/25 px-2.5 py-1 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-wider" data-id="element-15">
                <Check className="w-3 h-3" data-id="element-16" />
                Incluido
              </div>

              {/* Icon */}
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/25 flex items-center justify-center text-3xl mb-5 shadow-inner" data-id="element-17">
                {benefit.icon}
              </div>

              {/* Title + value */}
              <div className="mb-2" data-id="element-18">
                <h3 className="text-xl sm:text-2xl font-black text-text-main leading-tight" data-id="element-19">
                  {benefit.title}
                </h3>
                <p className="text-text-sec text-xs sm:text-sm font-medium mt-1" data-id="element-20">
                  Valor:{' '}
                  <span className="text-text-main font-bold line-through" data-id="element-21">
                    {benefit.value}
                  </span>{' '}
                  · Hoy:{' '}
                  <span className="text-cta-green font-bold" data-id="element-22">
                    Gratis con el Kit
                  </span>
                </p>
              </div>

              {/* Description */}
              <p className="text-text-sec text-sm sm:text-base leading-relaxed mb-5" data-id="element-23">
                {benefit.desc}
              </p>

              {/* Sub-bullets — concrete benefits */}
              <ul className="space-y-2 mt-auto" data-id="element-24">
                {benefit.bullets.map((b, j) => <li key={j} className="flex items-start gap-2.5 text-text-main text-sm sm:text-[15px] font-medium" data-id="element-25">
                    <Check className="w-4 h-4 text-cta-green flex-shrink-0 mt-0.5" data-id="element-26" />
                    <span data-id="element-27">{b}</span>
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}